import { withStyles } from '@material-ui/core';

import { Slider } from './Slider';
import { VirtualizeSlider } from './VirtualizeSlider';
import { withControls, styles } from './withControls';

export { ControlProps, SlideRendererParams, SlideRenderer } from './types';

export const SliderWithControls = withStyles(styles)(withControls(Slider));
export const VirtualizeSliderWithControls = withStyles(styles)(
  withControls(VirtualizeSlider),
);
